import PrmButton from '@NitrexGroup/primevue/button';
import {
  ButtonHTMLAttributes,
} from 'vue';

import {
  TQTooltipPosition,
} from '../../directives/q-tooltip/q-tooltip-position.ts';
import type {
  TIcon,
} from '../../types/icon.ts';

type TPrmButtonProps = InstanceType<typeof PrmButton>['$props'];

export const qmulusButtonSeverity = [
  'primary',
  'secondary',
  'tertiary',
  'danger',
] as const;
export type TQmulusButtonSeverity = typeof qmulusButtonSeverity[number];

/**
 * - `labeled`: icon and label
 * - `iconOnly`: the icon in the color of the severity, the label in the tooltip only if `tooltip` is set
 * - `inline`: the icon as text button, e.g. an action in a table row; always shows a tooltip
 */
export const qmulusButtonPresentation = [
  'labeled',
  'iconOnly',
  'inline',
] as const;
export type TQmulusButtonPresentation = typeof qmulusButtonPresentation[number];

export interface IQmulusButtonBaseProps {
  label: string,
  severity?: TQmulusButtonSeverity,
  disabled?: boolean,
  loading?: boolean,
  tooltip?: string,
  tooltipPosition?: TQTooltipPosition,
  /* If set to true, long text will be truncated and suffixed with ... */
  truncateLabel?: boolean,
  onClick?: ButtonHTMLAttributes['onClick'],
  ariaControls?: string,
  ariaHasPopup?: boolean,
}

export interface IQmulusButtonLabeledProps extends IQmulusButtonBaseProps {
  presentation?: 'labeled',
  icon?: TIcon,
}

export interface IQmulusButtonIconProps extends IQmulusButtonBaseProps {
  presentation: Exclude<TQmulusButtonPresentation, 'labeled'>,
  icon: TIcon,
}

export type TQmulusButtonProps = IQmulusButtonLabeledProps | IQmulusButtonIconProps;

export const severityMap: Record<TQmulusButtonSeverity, TPrmButtonProps> = {
  primary: {},
  secondary: {
    severity: 'secondary',
  },
  tertiary: {
    severity: 'secondary',
    outlined: true,
  },
  danger: {
    severity: 'danger',
    text: true,
  },
};

// A primary action belongs to an action area such as a page header or a dialog footer, never to a row.
export function getPresentedSeverity(severity: TQmulusButtonSeverity, presentation: TQmulusButtonPresentation): TQmulusButtonSeverity {
  if (presentation === 'inline' && severity !== 'danger') {
    return 'tertiary';
  }
  return severity;
}
